// action types
import { createRequestTypes } from "../../utils";

// Fetch ingredients
export const FETCH_INGREDIENTS = createRequestTypes("FETCH_INGREDIENTS");
export const FETCH_INGREDIENT_DETAIL = createRequestTypes("FETCH_INGREDIENT_DETAIL");

// Create/Update/Delete ingredient
export const CREATE_INGREDIENT = createRequestTypes("CREATE_INGREDIENT");
export const UPDATE_INGREDIENT = createRequestTypes("UPDATE_INGREDIENT");
export const DELETE_INGREDIENT = createRequestTypes("DELETE_INGREDIENT");

// Admin actions
export const FETCH_PENDING_INGREDIENTS = createRequestTypes("FETCH_PENDING_INGREDIENTS");
export const APPROVE_INGREDIENT = createRequestTypes("APPROVE_INGREDIENT");
export const REJECT_INGREDIENT = createRequestTypes("REJECT_INGREDIENT");
export const PROMOTE_INGREDIENT = createRequestTypes("PROMOTE_INGREDIENT");

// UI State
export const SET_INGREDIENT_FILTERS = 'SET_INGREDIENT_FILTERS';
export const CLEAR_INGREDIENT_DETAIL = 'CLEAR_INGREDIENT_DETAIL';
export const SET_SELECTED_INGREDIENT = 'SET_SELECTED_INGREDIENT';

// ==================== INGREDIENTS ====================

export const fetchIngredientsRequest = (filters = {}) =>
    ({ type: FETCH_INGREDIENTS.REQUEST, payload: filters });

export const fetchIngredientsSuccess = (ingredients) =>
    ({ type: FETCH_INGREDIENTS.SUCCESS, payload: ingredients });

export const fetchIngredientsFailure = (error) =>
    ({ type: FETCH_INGREDIENTS.FAILURE, payload: error });

export const fetchIngredientDetailRequest = (ingredientId) =>
    ({ type: FETCH_INGREDIENT_DETAIL.REQUEST, payload: { ingredientId } });

export const fetchIngredientDetailSuccess = (ingredient) =>
    ({ type: FETCH_INGREDIENT_DETAIL.SUCCESS, payload: ingredient });

export const fetchIngredientDetailFailure = (error) =>
    ({ type: FETCH_INGREDIENT_DETAIL.FAILURE, payload: error });

// ==================== CREATE/UPDATE/DELETE ====================

export const createIngredientRequest = (ingredientData) =>
    ({ type: CREATE_INGREDIENT.REQUEST, payload: ingredientData });

export const createIngredientSuccess = (ingredient) =>
    ({ type: CREATE_INGREDIENT.SUCCESS, payload: ingredient });

export const createIngredientFailure = (error) =>
    ({ type: CREATE_INGREDIENT.FAILURE, payload: error });

export const updateIngredientRequest = (ingredientId, ingredientData) =>
    ({ type: UPDATE_INGREDIENT.REQUEST, payload: { ingredientId, ingredientData } });

export const updateIngredientSuccess = (ingredient) =>
    ({ type: UPDATE_INGREDIENT.SUCCESS, payload: ingredient });

export const updateIngredientFailure = (error) =>
    ({ type: UPDATE_INGREDIENT.FAILURE, payload: error });

export const deleteIngredientRequest = (ingredientId) =>
    ({ type: DELETE_INGREDIENT.REQUEST, payload: { ingredientId } });

export const deleteIngredientSuccess = (ingredientId) =>
    ({ type: DELETE_INGREDIENT.SUCCESS, payload: { ingredientId } });

export const deleteIngredientFailure = (error) =>
    ({ type: DELETE_INGREDIENT.FAILURE, payload: error });

// ==================== ADMIN ACTIONS ====================

export const fetchPendingIngredientsRequest = () =>
    ({ type: FETCH_PENDING_INGREDIENTS.REQUEST });

export const fetchPendingIngredientsSuccess = (ingredients) =>
    ({ type: FETCH_PENDING_INGREDIENTS.SUCCESS, payload: ingredients });

export const fetchPendingIngredientsFailure = (error) =>
    ({ type: FETCH_PENDING_INGREDIENTS.FAILURE, payload: error });

export const approveIngredientRequest = (ingredientId, notes = null) =>
    ({ type: APPROVE_INGREDIENT.REQUEST, payload: { ingredientId, notes } });

export const approveIngredientSuccess = (ingredient) =>
    ({ type: APPROVE_INGREDIENT.SUCCESS, payload: ingredient });

export const approveIngredientFailure = (error) =>
    ({ type: APPROVE_INGREDIENT.FAILURE, payload: error });

export const rejectIngredientRequest = (ingredientId, notes = null) =>
    ({ type: REJECT_INGREDIENT.REQUEST, payload: { ingredientId, notes } });

export const rejectIngredientSuccess = (ingredient) =>
    ({ type: REJECT_INGREDIENT.SUCCESS, payload: ingredient });

export const rejectIngredientFailure = (error) =>
    ({ type: REJECT_INGREDIENT.FAILURE, payload: error });

export const promoteIngredientRequest = (ingredientId, notes = null) =>
    ({ type: PROMOTE_INGREDIENT.REQUEST, payload: { ingredientId, notes } });

export const promoteIngredientSuccess = (ingredient) =>
    ({ type: PROMOTE_INGREDIENT.SUCCESS, payload: ingredient });

export const promoteIngredientFailure = (error) =>
    ({ type: PROMOTE_INGREDIENT.FAILURE, payload: error });

// ==================== UI STATE ====================

export const setIngredientFilters = (filters) =>
    ({ type: SET_INGREDIENT_FILTERS, payload: filters });

export const clearIngredientDetail = () =>
    ({ type: CLEAR_INGREDIENT_DETAIL });

export const setSelectedIngredient = (ingredient) =>
    ({ type: SET_SELECTED_INGREDIENT, payload: ingredient });
